import './barChart.css'

import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { clusterSorterer, hexToRGBA } from 'utils'

import { ResponsiveBar } from '@nivo/bar'

const emptyColors = {
  avgRevenueColor: '#9e9e9e',
  avgRevenueComparedColor: hexToRGBA('#9e9e9e', 0.6),
}

const BarChart = ({ data, newStores, ...props }) => {
  const maxValue = Math.max(0, ...(data || []).map(item => item.totalRevenue))
  const hasData = maxValue > 0
  const emptyValue = hasData ? maxValue * 0.07 : 100
  const adjustedData = (data || [])
    .map(item =>
      item.totalRevenue
        ? item
        : {
            ...item,
            avgRevenue: emptyValue,
            avgRevenueCompared: emptyValue,
            ...emptyColors,
          },
    )
    .sort(clusterSorterer)

  const keys = newStores ? ['avgRevenue'] : ['avgRevenue', 'avgRevenueCompared']

  return (
    <div className={classNames('revenue-bar', { 'is-empty': !hasData })}>
      <ResponsiveBar
        colorBy={({ id, data }) => data[`${id}Color`]}
        padding={0.35}
        borderRadius={7}
        enableGridY={false}
        groupMode="grouped"
        enableLabel={false}
        isInteractive={false}
        axisBottom={{
          tickSize: 0,
          tickPadding: 5,
          tickRotation: 0,
          legend: '',
          legendPosition: 'middle',
          legendOffset: 0,
        }}
        margin={{
          top: 40,
          right: 0,
          bottom: 25,
          left: 0,
        }}
        data={adjustedData}
        keys={keys}
        indexBy="type"
        {...props}
      />
    </div>
  )
}

BarChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      avgRevenue: PropTypes.number,
      avgRevenueColor: PropTypes.string,
      totalRevenue: PropTypes.number,
      totalRevenueColor: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  newStores: PropTypes.bool,
}

export default BarChart
